module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABXUlEQVQ4jZ3VP08UQRzG8c9N4CrsgQRCQYFvgMZGLCw9+dNR+AYkRCp8BWADmPAG7D0BteausTGhoOYKAgE6a8UEKHY2rJdZbvBJNplsnuc7s/ub+U3j5dI7CTXxCq/xDOP4gwscYQ9f8bc/OJSAzWMHk4lJZuKzjB7W8K1qCpVxAxtoJ2ApTeMgZhqpFX7ESgaoqgbWMVJmyxUu/AesqrdYLIFNbNcYP+EpTjOgW2iGSK77Zy/wG3MZ0EksBkVV6zSBThznQOcDZgeYph4BnQ0YHQBMQX/V+MYCrjOA3O+1WwzXmQKuMmCneB5hXTyp8V0FHGfA5uK4q/j8Ov0M2H/AcF6BdQbAYC/gcwymdKg4njmwc7TLoiR7GN7gJAMmMq7Ls9zGbkaoTruR8U/7WsWmopKP0YeY1Q+8wXss4SwD1ENL0b5uypepjv0F36O55f4KgEv8UOyMA4kr4A4cj0YjQoYLIwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-right-dark.png
// module id = F1kZ
// module chunks = 5